import { clientModsApi } from '../api/client-mod-templates';
import { useApp } from '../app-context';
import { usePoll } from '../hooks/usePoll';
import { ClientPackProblems } from './ClientPackProblems';
import { ErrorAlert } from './ui';

export function ServerClientPackProblems({
  serverId,
  remove,
  removable,
  modpackProjects = [],
}: {
  serverId: string;
  remove: (projectId: string) => void;
  removable: string[];
  modpackProjects?: string[];
}) {
  const { canOperate } = useApp();
  const data = usePoll(() => clientModsApi.verification(serverId), 5000, [serverId]);
  return (
    <>
      <ErrorAlert error={data.error} />
      {data.data?.state === 'failed' && (
        <section className="card card-body stack">
          <h3>クライアント起動テストの原因</h3>
          <ClientPackProblems
            check={data.data}
            modpackProjects={modpackProjects}
            actions={(problem) =>
              canOperate && problem.projectId && removable.includes(problem.projectId) ? (
                <button className="btn small" onClick={() => remove(problem.projectId!)}>
                  外す
                </button>
              ) : null
            }
          />
          <p className="small muted">
            下の Mod 一覧で区分や構成を変更できます。外す操作は変更予定に入り、依存関係を確認して変更を依頼します。
          </p>
        </section>
      )}
    </>
  );
}
